import axios from 'axios';
import { GET_EVENTI_AGENDA, GET_EVENTO_AGENDA, AGGIUNGI_EVENTO, MODIFICA_EVENTO, ELIMINA_EVENTO, GET_EVENTO_AGENDA_STATISTICHE, GET_UTENTI, AGENDA_ERROR } from './types';
import { setAlert } from './alert';



export const getEventiAgenda = () => async dispatch => {
    try{
        const res = await axios.get('/api/agenda/getEventiAgenda');
        dispatch({
            type: GET_EVENTI_AGENDA,
            payload: res.data
        });
    }catch(err){
        dispatch({
            type: AGENDA_ERROR
        });
    }
}

export const getUtenti = () => async dispatch => {
    try{
        const res = await axios.get('/api/agenda/getUtenti');
        dispatch({
            type: GET_UTENTI,
            payload: res.data
        });
    }catch(err){
        dispatch({
            type: AGENDA_ERROR
        });
    }
}
export const getEventoAgenda = ({ idEvento }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    const body = JSON.stringify({ idEvento });
    try{
        const res = await axios.post('/api/agenda/getEventoAgenda', body, config);
        dispatch({
            type: GET_EVENTO_AGENDA,
            payload: res.data
        });
    }catch(err){
        const errors = err.response.data.errors;
        if(errors){
            errors.forEach(error => dispatch(setAlert(error.msg, 'error')));
        }
        dispatch({
            type: AGENDA_ERROR
        });
    }
};

export const aggiungiEvento = ({ titolo, descrizione, data, orario, link }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    const body = JSON.stringify({ titolo, descrizione, data, orario, link });
    try{
        const res = await axios.post('/api/agenda/aggiungiEvento', body, config);
        dispatch({
            type: AGGIUNGI_EVENTO,
            payload: res.data
        });
        dispatch(setAlert("Evento aggiunto con successo!", 'success'))
    }catch(err){
        const errors = err.response.data.errors;
        if(errors){
            errors.forEach(error => dispatch(setAlert(error.msg, 'error')));
        }
        dispatch({
            type: AGENDA_ERROR
        });
    }
};

export const getEventiAgendaAdmin = ({ dataInizio, dataFine }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    const body = JSON.stringify({ dataInizio, dataFine });
    try{
        const res = await axios.post('/api/agenda/getEventiAgendaAdmin', body, config);
        dispatch({
            type: GET_EVENTI_AGENDA,
            payload: res.data
        });
    }catch(err){
        const errors = err.response.data.errors;
        if(errors){
            errors.forEach(error => dispatch(setAlert(error.msg, 'error')));
        }
        dispatch({
            type: AGENDA_ERROR
        });
    }
};

export const getRegistroEventoAgenda = ({ idEvento }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    const body = JSON.stringify({ idEvento });
    try{
        const res = await axios.post('/api/agenda/getRegistroEventoAgenda', body, config);
        dispatch({
            type: GET_EVENTO_AGENDA_STATISTICHE,
            payload: res.data
        });
    }catch(err){
        const errors = err.response.data.errors;
        if(errors){
            errors.forEach(error => dispatch(setAlert(error.msg, 'error')));
        }
        dispatch({
            type: AGENDA_ERROR
        });
    }
};

export const modificaEvento = ({ idEvento, meetingId, titolo, descrizione, data, orario, link }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    const body = JSON.stringify({ idEvento, meetingId, titolo, descrizione, data, orario, link });
    try{
        const res = await axios.post('/api/agenda/modificaEvento', body, config);
        dispatch({
            type: MODIFICA_EVENTO,
            payload: res.data
        });
        dispatch(setAlert("Evento modifcato con successo!", 'success'))
    }catch(err){
        const errors = err.response.data.errors;
        if(errors){
            errors.forEach(error => dispatch(setAlert(error.msg, 'error')));
        }
        dispatch({
            type: AGENDA_ERROR
        });
    }
};

export const eliminaEvento = ({ idEvento, meetingId }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    const body = JSON.stringify({ idEvento, meetingId });
    try{
        const res = await axios.post('/api/agenda/eliminaEvento', body, config);
        dispatch({
            type: ELIMINA_EVENTO,
            payload: res.data
        });
        dispatch(setAlert("Evento eliminato con successo!", 'success'))
    }catch(err){
        const errors = err.response.data.errors;
        if(errors){
            errors.forEach(error => dispatch(setAlert(error.msg, 'error')));
        }
        dispatch({
            type: AGENDA_ERROR
        });
    }
};